// eslint-disable  prefer-arrow/prefer-arrow-functions
import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
// import { BrandConfig } from '@models/BrandConfig';
import { IPartnerData } from '@models/WhitelabelConfig';

export function createInititalState(): IPartnerData {
	return {
		id: '',
		friendlyName: '',
		partnerPhoneNumber: '',
	} as IPartnerData;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'brandConfig', resettable: true })
export class BrandConfigStore extends Store<IPartnerData> {
	constructor() {
		super(createInititalState());
	}
}
